module.exports = __webpack_public_path__ + "img/kyle.17d372e0.png";